import { render, staticRenderFns } from "./ProjectBulkOperationPage.vue?vue&type=template&id=0cae2ac3&"
import script from "./ProjectBulkOperationPage.vue?vue&type=script&lang=js&"
export * from "./ProjectBulkOperationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports